import { DataFieldRuleValidator } from "./types";

export const dataFieldIsNotEmpty: DataFieldRuleValidator = {
	validate(_, __, dataFieldValue): boolean {
		return dataFieldValue !== null;
	},

	getErrorMessage: () => {
		return "";
	},
};
